import { siteContent } from '@/mocks/siteContent';

export default function HeroSection() {
  const { hero } = siteContent;

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20inviting%20modern%20workspace%20with%20natural%20wood%20desk%20surface%20featuring%20an%20open%20notebook%20and%20laptop%2C%20soft%20golden%20morning%20light%20streaming%20through%20large%20windows%20with%20sheer%20cream%20curtains%2C%20potted%20olive%20tree%20and%20dried%20botanical%20arrangements%2C%20warm%20terracotta%20beige%20and%20ivory%20color%20palette%2C%20calm%20productive%20editorial%20photography%20with%20shallow%20depth%20of%20field%20and%20organic%20textures&width=1800&height=1200&seq=hero-bg-sugargoo-v2&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50/90"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-sparkling-line"></i>
          </div>
          <span className="whitespace-nowrap">Updated for 2026 &bull; Free Resource</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
          {hero.title}
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed mb-8">
          {hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-foreground-900 bg-background-50 border-2 border-foreground-200 rounded-lg hover:border-foreground-400 hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {hero.trustBadges.map((badge, idx) => (
            <div key={idx} className="flex items-center gap-1.5 text-xs text-foreground-500">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
              </div>
              <span className="whitespace-nowrap">{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}